import { Header, flexRender } from '@tanstack/react-table';
import classnames from 'classnames';
import * as React from 'react';

import { SortAscIcon, SortDescIcon, UnsortedIcon } from '@icons';

import styles from '../Table.module.scss';

import { ColumnMetaDef } from './TableFilter';

type TableHeaderProps<T> = {
  header: Header<T, unknown>;
  disableSorting?: boolean;
};

const defaultWidth = 150;

function TableHeader<T>({ header, disableSorting }: TableHeaderProps<T>) {
  const { id, column, getSize } = header;
  const meta = column.columnDef.meta as ColumnMetaDef;
  const { contentAlignment } = meta || {};

  const text = !header.isPlaceholder && flexRender(column.columnDef.header, header.getContext());
  const canSort = !disableSorting && column.getCanSort();

  const classes = classnames({
    [styles.sortable]: canSort,
    [styles[contentAlignment || '']]: contentAlignment,
  });

  const sortDirection = column.getIsSorted() as string;
  const sortIcon = {
    asc: <SortAscIcon />,
    desc: <SortDescIcon />,
  }[sortDirection] || <UnsortedIcon />;

  const width = getSize();
  const widthStyle = width === defaultWidth ? undefined : `${getSize()}px`;

  const handleSort = (e: unknown) => {
    if (!canSort) return;
    column.getToggleSortingHandler()?.(e);
  };

  return (
    <th key={id} className={styles.headerCol} style={{ width: widthStyle }}>
      <div className={classes} onClick={handleSort}>
        {text}
        {canSort && <span className={styles.sortIcon}>{sortIcon}</span>}
      </div>
    </th>
  );
}

export { TableHeader };
